export const tgChannels = {
  main: 'https://t.me/Singapore_Jobs_SG',
  partTimeAgency: 'https://t.me/SgPartTimeAgency',
  fullTimeAgency: 'https://t.me/SgFullTimeAgency',
  partTimer: 'https://t.me/JobsPartTimer',
  bot: 'https://t.me/SgJobBot',
};
